import React, {Component} from 'react';
import {
    Platform,
    View,
    ScrollView,
    Dimensions,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator, RefreshControl,
    Image,

} from 'react-native';
import {connect} from 'react-redux';

import {moderateScale, verticalScale} from '../../../tools/Scaling';
import Colors from '../../../tools/Colors';
import HMActionBar from '../../../customviews/HMActionBar';
import {AsyngStorageClass} from '../../../tools/AsyngStorageClass';
import {
    callWebservice as callWebserviceSplash,
    serviceActionSetState,
} from '../splash/action/ActionSplashGetAllData';

const {width: SCREEN_WIDTH} = Dimensions.get('window');
const SLIDER_HEIGHT = verticalScale(180);
const HEADER_HEIGHT = Platform.OS === 'ios' ? verticalScale(64) : verticalScale(50);
const SCROLL_HEIGHT = SLIDER_HEIGHT - HEADER_HEIGHT;
const THEME_COLOR = Colors.colorPrimary;
import i18n from '../../../I18n/i18n.js';
import HMListDiffSize from '../../../customviews/HMListDiffSize';


const IS_ANDROID = Platform.OS === 'android';
const SLIDER_1_FIRST_ITEM = 0;
let content = null;
// import {DialogUpdateAppCustomize} from "../../../customviews/DialogUpdateAppCustomize";
import moment from 'moment-jalaali';
import store from '../../../redux/store';
import {typeExport} from '../../../redux/store/type';
import HMTextView from '../../../customviews/HMTextView';
import HMImageView from '../../../customviews/HMImageView';
import * as  NavigationService from '../../../redux/NavigationService';

import HMSwiper from '../../../customviews/swiper/HMSwiper';
import {DialogUpdateAppCustomize} from '../../../customviews/dialogUpdateApp/DialogUpdateAppCustomize';
import {GoLink, selectMenu} from '../../../tools/Tools1';
import PathFile from '../../../assets/PathFile';
import HMIcon from '../../../customviews/HMIcon';
import HMGradient from '../../../customviews/gradient';
// import StoryContainer from '../../socket/modules/statusDetails/stories/StoryContainer';
// import {getDateTimeStatusFormat} from '../../socket/utils/helperFunctions';
// import imageAndroidBack from '../../socket/assets/images/left_android.png';
// import imageIOSBack from '../../socket/assets/images/left_ios.png';
// import imgProfile from '../../socket/assets/images/user.png';

moment.locale('fa');
moment.loadPersian();

class MainScreen extends Component {

    wp(percentage, viewportWidth) {
        const value = (percentage * viewportWidth) / 100;
        return Math.round(value);
    }

    constructor(props) {
        super(props);

        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === 'web' ? 1 : typeExport._WIDTH;

        if (Platform.OS === 'web') {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;
            const slideWidth = this.wp(75, viewportWidth);
            const itemHorizontalMargin = this.wp(2, viewportWidth);

            sliderWidth = viewportWidth;
            itemWidth = (slideWidth + itemHorizontalMargin * 2) + 55;
        }
        this.state = {
            widthOriginal: widthOriginal,

            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,


            /*        itemWidth: 1,
                    sliderWidth: 1,
                    slideHeight: 1,*/
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,

            modalHeight: 0,
            ddd: [
                'The min size must be a number.',
                'The min size must be less than 4.',
                'The max size must be a number.',
            ],

            //   entries: props.DataSplashScreen.results.slider

        };
        content = this;
    }


    componentWillReceiveProps(props) {

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true});
    }

    componentDidMount() {
        // this.props.navigation.addListener('focus', () => {
        //     this.setState({focus:true})
        //     console.log('@@@@@@focus', this.props);
        //
        //     /*   store.dispatch(serviceActionListFilter([]))
        //        props.callserviceActionRefresh();
        //        this.getData(1)*/
        //     }
        // )
        // this.props.navigation.addListener('blur', () => {
        //     this.setState({focus:true})
        //
        //     console.log('@@@@@@blur', this.props);
        //
        //     }
        // )

        //console.log('@@@@@@yyy',this.props.navigation?.isFocused(), this.props?.route?.key?.toString());

        if (this.props.navigation?.isFocused()) {
            let {DataSplashScreen} = this.props;
            if (DataSplashScreen.STATE && DataSplashScreen.STATE.type) {
                setTimeout(function () {
                    if (DataSplashScreen.STATE?.typeSelectMenu) {
                        var resultItem = DataSplashScreen?.results?.menus?.find(k => k.type === DataSplashScreen.STATE?.typeSelectMenu);

                        resultItem && selectMenu(resultItem);
                        store.dispatch(serviceActionSetState(null));
                    }
                    else {
                        NavigationService.navigateParams(DataSplashScreen.STATE.type, {item: DataSplashScreen.STATE.item});
                        store.dispatch(serviceActionSetState(null));
                    }

                    // alert("df")
                }, 10);
                // NavigationService.navigateParams(DataSplashScreen.STATE.type);
                // NavigationService.navigateParams(DataSplashScreen.STATE.type, {item: DataSplashScreen.STATE.item});
            }
            if (Platform.OS === 'web') {
                window.addEventListener('resize', function (event) {
                    const IS_IOS = Platform.OS === 'ios';
                    let viewportWidth = document.body.clientWidth;
                    let viewportHeight = document.body.clientHeight;

                    function wp(percentage) {
                        const value = (percentage * viewportWidth) / 100;
                        return Math.round(value);
                    }

                    const slideHeight = viewportHeight * 0.35;
                    const slideWidth = wp(75);
                    const itemHorizontalMargin = wp(2);

                    const sliderWidth = viewportWidth;
                    const itemWidth = (slideWidth + itemHorizontalMargin * 2) + 55;

                    content.setState({
                            widthOriginal: document.body.clientWidth,
                            widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                            //    widthV: document.body.clientWidth,
                            heightV: document.body.clientHeight,
                            itemWidth: itemWidth,
                            sliderWidth: sliderWidth,
                            slideHeight: slideHeight,
                        },
                    );


                });
            }
            //     if ((global._loadDataCount && global._loadDataCount > 0) || !(this.props.DataSplashScreen.results))
            if (typeExport._TypeApp !== '1888') {
                this.getDataServerSplash();
            }
            // else
            //     global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1;
        }


    }

    async getDataServerSplash() {

        let dataSplash = this.props.DataSplashScreen;
        if (dataSplash.TypeLogin == 2 || dataSplash.TypeLogin == 1 || dataSplash.TypeLogin == null) {
            let paramss = {
                'token': dataSplash.token,
                'token_mahale': dataSplash.tokenMahaleh,
                'tokenLaravel': dataSplash.tokenLaravel,
                'id': 1,
                'lang': i18n.locale,
                'City': dataSplash.City,
                'imei': 0,
                'token_fb': dataSplash.token_fb,
            };
            if (dataSplash.Connection) {

                if (global.GoOfflineToMain || !(this.props.DataSplashScreen.results)) {
                    if ((global._loadDataCount && global._loadDataCount > 0) || (global.GoOfflineToMain || !(dataSplash.TypeLogin == 2 ? dataSplash.resultsShahrdar : dataSplash.results))) {
                        if (dataSplash.TypeLogin == 2) {
                            store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));
                        } else {
                            store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));

                        }
                        //  this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, token, token_fb, imageBack);

                    }
                    else {
                        global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1;
                    }
                }


                await AsyngStorageClass.setAsyng('splash' + global.IdCity, dataSplash.results);

                if (dataSplash.TypeLogin == 2) {
                    await AsyngStorageClass.setAsyng('splashShahrdar' + global.IdCity, dataSplash.resultsShahrdar);
                } else {
                    await AsyngStorageClass.setAsyng('splashSaina' + global.IdCity, dataSplash.resultsSaina);
                }

            }
            else {
                if (dataSplash.TypeLogin == 2) {
                    store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));
                } else {
                    store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));

                }
            }
        }

    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }

    /*  static ShowMessageBack(text) {
          content.refs.toast.show(text ? text : i18n.t('constant.DescExit'), 1200, () => {
              // something you want to do at close
          });
      }
  */
    render() {

        const {slider1ActiveSlide} = this.state;
        // this.state.dataSource = this.props.data.results.slider;

        //  let {results} = this.props.DataSplashScreen;
        let store_data = this.props.DataSplashScreen;
        let {results, City} = store_data;

        let checkLoginCloud = (store_data.TypeLogin == 2);
        let DataSplashScreenSaina = checkLoginCloud ? (store_data.resultsShahrdar ? store_data.resultsShahrdar.result : null) : (store_data.resultsSaina ? store_data.resultsSaina.result : null);

        const checkMenuCloud = this.state.widthOriginal > 1400 && (typeExport._NameApp === 'Cloud' || typeExport._NameApp === 'CloudTest');
        //
        // let mB = moment("1399/05/20", 'jYYYY/jM/jD');
        // let mE = moment("1399/05/20", 'jYYYY/jM/jD');
        // //let m = "1399/05/20";
        // let beginDate = mB.subtract(1, 'month').locale('fa').format('jYYYY/jM/jD');
        // let endDate = mE.add(1, 'month').locale('fa').format('jYYYY/jM/jD');
        // // let endDate = "1399/05/28";
        //
        // if ((typeExport._NameApp === "Cloud"|| typeExport._NameApp === "CloudTest") && Tools.CheckValue(City))
        //     typeExport._NameCity = City?.name;

        return (
            <View style={{position: 'relative', flex: 1}}>

                {
                    DataSplashScreenSaina?.info?.weather && DataSplashScreenSaina?.info?.background && <HMGradient
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: 0,
                            flex: 1,
                            // alignItems: 'center'
                        }}
                        color2={Colors.colorPrimary}
                        color1={Colors.green1}

                        x1="0%" y1="100%" x2="0%" y2="70%"

                    />
                }

                {/*       <HMImageBackground/>*/}

                <KeyboardAvoidingView
                    style={[{
                        width: '100%', height: '100%',
                        //  backgroundColor: DataSplashScreenSaina?.info?.background

                    }]}
                    behavior={'padding'}
                    enabled={Platform.OS === 'ios'}>
                    <HMActionBar
                        profile={(typeExport._NameApp === 'Cloud' || typeExport._NameApp === 'CloudTest') ? (store.getState().reducerSplashGetAllData.token != null) : true}
                        menu
                        props={this.props} statusBarTransparent
                        // text={(typeExport._NameApp === "Cloud"|| typeExport._NameApp === "CloudTest") ? typeExport._NameCity + " من ": i18n.t('appName') }
                        text={i18n.t('appName')}
                        //  text={i18n.t('constant.Information')}

                        headerVisibility more_menu
                        onBackPress={() => this.props.navigation.pop()}

                        ViewCenter={DataSplashScreenSaina?.info?.weather ? () => {
                                return <View
                                    style={{
                                        flex: 1,
                                        // width: moderateScale(300),
                                        //   height: moderateScale(56),
                                        paddingHorizontal: moderateScale(2),
                                        //  paddingVertical: moderateScale(8),
                                        alignSelf: 'center',
                                        flexDirection: 'row',
                                        // borderBottomStartRadius: moderateScale(120),
                                        // borderBottomEndRadius: moderateScale(120),
                                        marginBottom: moderateScale(6),
                                        justifyContent: 'space-between',
                                        // position: "absolute",
                                        // bottom: 25,
                                        // left: "40%",
                                        // borderRadius: 35,
                                        // //backgroundColor: "black",
                                        // transform: [{ scaleX: 5 }, { scaleY: 1 }],
                                        //backgroundColor: "#0087ee"
                                        backgroundColor: Colors.colorPrimary,
                                    }}>
                                    <View
                                        style={{
                                            flex: .4,
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            //justifyContent: "center"
                                        }}>
                                        <View style={{alignItems: 'center'}}>
                                            <HMIcon


                                                //type={"svg"}
                                                //uri={DataSplashScreenSaina?.info?.weather?.image_temp}
                                                // height={moderateScale(28)}
                                                // width={moderateScale(28)}

                                                type={'image'}
                                                source={{uri: DataSplashScreenSaina?.info?.weather?.image_temp}}


                                                style={{
                                                    height: moderateScale(30),
                                                    width: moderateScale(46),
                                                    // fontSize: moderateScale(20),
                                                    // color: Colors.blue,
                                                    // marginHorizontal: moderateScale(4),
                                                    //  marginRight: moderateScale(4),
                                                    // marginLeft: moderateScale(4),
                                                    //  marginTop: moderateScale(3)
                                                }}
                                                // styleRoot={{
                                                //     width: moderateScale(28),
                                                //     height: moderateScale(28),
                                                //     borderRadius: moderateScale(12),
                                                //     borderWidth: moderateScale(12),
                                                //     borderColor: Colors.gray,
                                                //     overflow: "hidden",
                                                //     marginHorizontal: moderateScale(4)
                                                // }}
                                            />
                                            <HMTextView
                                                type={'bold'}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: 'center',
                                                        color: Colors.white,
                                                        fontSize: moderateScale(13),
                                                        marginEnd: moderateScale(4),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={DataSplashScreenSaina?.info?.weather?.temp + '  C°'}
                                            />
                                        </View>

                                    </View>


                                    <Image
                                        resizeMode={'contain'}
                                        style={{
                                            height: moderateScale(Platform.OS === 'web' ? 90 : 65),
                                            width: moderateScale(Platform.OS === 'web' ? 90 : 65),

                                        }}
                                        // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                                        source={PathFile.image.logo}
                                    />


                                    <View style={{
                                        flex: .4,
                                        // flexDirection: "row",
                                        alignItems: 'flex-end',
                                        justifyContent: 'center',
                                    }}>

                                        {/*    <Image resizeMode={'contain'} source={{
                                                uri: 'data:image/png;base64,' + PathFile.base64Image.SelectDate,
                                                //   uri:'data:image/png;base64,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',
                                                scale: 1
                                            }} style={{
                                                width: "100%",
                                                height: "100%",
                                            }}/>*/}
                                        <View style={{alignItems: 'center'}}>
                                            <HMIcon

                                                //source={require('../../../../../assets/img/success.png')}
                                                //source={PathFile.image.background}
                                                //svg={PathFile.svg.add}

                                                //type={"image"}
                                                // resizeMode="cover"
                                                // source={{uri: DataSplashScreenSaina?.info?.image_date}}
                                                // source={{
                                                //     uri: 'data:image/png;base64,' + PathFile.base64Image.SelectDate,
                                                //     scale: 1,
                                                // }}
                                                name={'calendar-outline'}

                                                style={{

                                                    // height: moderateScale(28),
                                                    //  width: moderateScale(36),
                                                    fontSize: moderateScale(22),
                                                    marginEnd: moderateScale(6),
                                                }}
                                                // type={"svg"}
                                                // uri={DataSplashScreenSaina?.info?.image_date}
                                                // height={moderateScale(36)}
                                                // width={moderateScale(36)}


                                            />
                                            {/*<HMTextView*/}
                                            {/*type={"bold"}*/}

                                            {/*style={[*/}
                                            {/*{*/}
                                            {/*// position: 'absolute',*/}
                                            {/*//  bottom: 0,*/}
                                            {/*// height: moderateScale(44),*/}
                                            {/*// width: '100%',*/}
                                            {/*textAlign: "center",*/}
                                            {/*color: Colors.white,*/}
                                            {/*fontSize: moderateScale(13),*/}
                                            {/*marginEnd: moderateScale(4),*/}
                                            {/*//  padding: moderateScale(1),*/}

                                            {/*// backgroundColor: 'rgba(0,0,0,0.25)',*/}
                                            {/*}]}*/}
                                            {/*numberOfLines={2}*/}
                                            {/*//  text={moment(new Date()).format("dddd jDD jMMMM")}*/}
                                            {/*//text={moment(new Date()).format("dddd")}*/}
                                            {/*text={moment(new Date()).format("dddd")}*/}
                                            {/*/>*/}
                                            <HMTextView
                                                type={'bold'}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: 'center',
                                                        color: Colors.white,
                                                        fontSize: moderateScale(13),
                                                        marginTop: moderateScale(4),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={moment(new Date()).format('dddd') + ' ' + DataSplashScreenSaina?.info?.currentdate}
                                            />
                                        </View>

                                    </View>
                                </View>;
                            }
                            :
                            null}

                        style={[{height: DataSplashScreenSaina?.info?.weather && moderateScale(Platform.OS === 'web' ? 95 : 80)},

                            /*     {
                                     borderBottomColor: "#ee7206",
                                     borderBottomWidth: moderateScale(5),
                                     //   borderBottomEndRadius: moderateScale(Platform.OS === "web" ? 60 : 50),
                                     // borderBottomStartRadius: moderateScale(Platform.OS === "web" ? 60 : 50),
                                     overflow: "hidden",

                                     // marginTop: -moderateScale(25)
                                 }*/
                        ]}
                    />

                    {/*     <TouchableOpacity style={{width:'100%',height:moderateScale(40),backgroundColor:"#ee003d"}}
                    onPress={()=>{
                        GoLink("https://app137.ilam.ir/splash?token=re5Bd0jibGcUY82FY6fYxP9RIGiSLVG5lX9w/rC93YPzaHUM9t+Y3I3MPKvfpwWV")
                    }}
                    />*/}
                    {/*    <View  style={{width: '100%', height: 100, backgroundColor: '#ee5a00'}}>
                        <View

                            style={{width: 80, height: 80, backgroundColor: '#eee525', position: 'absolute', right: 0}}>
                        </View>
                    </View>*/}
                    {
                        !this.props.DataSplashScreen.isLoadingBackground && (!this.props.DataSplashScreen.NoInternetDialogBackground) ?
                            null
                            :
                            <View
                                style={{
                                    width: '100%',
                                    //  flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: this.props.DataSplashScreen.NoInternetDialogBackground ? Colors.red :
                                        (DataSplashScreenSaina?.info?.weather && DataSplashScreenSaina?.info?.background) ? DataSplashScreenSaina?.info?.background : Colors.white

                                    ,
                                    alignSelf: 'center',
                                    padding: moderateScale(6),
                                }}
                            >
                                {this.props.DataSplashScreen.NoInternetDialogBackground ?
                                    <View
                                        style={{
                                            width: '100%',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',

                                        }}>


                                        <HMTextView
                                            type={'bold'}

                                            style={[
                                                {
                                                    // position: 'absolute',
                                                    //  bottom: 0,
                                                    // height: moderateScale(44),
                                                    // width: '100%',
                                                    textAlign: 'center',
                                                    color: Colors.white,
                                                    fontSize: moderateScale(11),
                                                    //  padding: moderateScale(1),

                                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                                }]}
                                            numberOfLines={2}
                                            text={'خطایی رخ داده مجددا تلاش نمایید'}
                                        />
                                        <View style={{width: moderateScale(4)}}/>
                                        <TouchableOpacity
                                            onPress={() => {
                                                this.getDataServerSplash();

                                            }}
                                            style={{
                                                // flex: .33,
                                                // width: '92%',
                                                // height: moderateScale(28),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.yellow,
                                                borderRadius: moderateScale(6),
                                                marginHorizontal: moderateScale(2),
                                                paddingHorizontal: moderateScale(4),
                                                paddingVertical: moderateScale(2),


                                            }}>

                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={i18n.t('constant.Update')}
                                                //  text={"ثبت و بستن تیکت"}
                                                type={'bold'}
                                                style={{
                                                    fontSize: moderateScale(10),
                                                    marginVertical: moderateScale(2),
                                                    //     marginHorizontal: moderateScale(4),
                                                    color: Colors.white,
                                                }}/>
                                        </TouchableOpacity>

                                    </View>
                                    :

                                    <View
                                        style={{
                                            width: '100%',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>


                                        <HMTextView
                                            type={'bold'}

                                            style={[
                                                {
                                                    // position: 'absolute',
                                                    //  bottom: 0,
                                                    // height: moderateScale(44),
                                                    // width: '100%',
                                                    textAlign: 'center',
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(11),
                                                    //  padding: moderateScale(1),

                                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                                }]}
                                            numberOfLines={2}
                                            text={i18n.t('constant.Update')}
                                        />
                                        <View style={{width: moderateScale(4)}}/>
                                        <ActivityIndicator color={Colors.secondaryColor} size={'small'}/>

                                    </View>
                                }
                            </View>


                    }
                    <ScrollView
                        refreshControl={
                            <RefreshControl refreshing={this.props.DataSplashScreen.isLoadingBackground}
                                            onRefresh={() => this.getDataServerSplash()
                                            }/>
                        }
                    >
                        <View style={{flex: 1}}>

                    {/*        <StoryContainer
                                images={[
                                    {
                                        id: 4,
                                        type: 'video',
                                        file: 'https://file-examples.com/storage/fe1207564e65327fe9c8723/2017/04/file_example_MP4_1280_10MG.mp4',
                                    },
                                    {
                                        id: 1,
                                        type: 'image',
                                        file: 'https://golbazarsurprize.ir/wp-content/uploads/2019/01/Screenshot_%DB%B2%DB%B0%DB%B1%DB%B9-%DB%B0%DB%B1-%DB%B0%DB%B5-%DB%B1%DB%B4-%DB%B1%DB%B9-%DB%B5%DB%B4-1-e1570276317384.png',
                                    },
                                    {
                                        id: 2,
                                        type: 'image',
                                        file: 'https://www.golbazar.com/media/catalog/product/cache/1082276b54a98a4f6302e4550b4d51e0/r/o/rose_bouquet.jpg',
                                    },
                                    {
                                        id: 3,
                                        type: 'image',
                                        file: 'https://palizhom.com/wp-content/uploads/2019/01/n82925908-72358854.jpg',
                                    },
                                    {
                                        id: 4,
                                        type: 'image',
                                        file: 'https://titigift.com/images/thumbs/0007388_-_550.jpeg',
                                    },
                                ]}
                                visible={true}
                                duration={40}
                                enableProgress={true}
                                userProfile={{
                                    userName: 'ahmad',
                                    userMessage: getDateTimeStatusFormat('23/524'),
                                    imageArrow:
                                        Platform.OS === 'android' ? imageAndroidBack : imageIOSBack,
                                    userImage: imgProfile,
                                    onImageClick: () => {
                                        // alert("gfhfg")
                                        //  navigation.goBack();
                                    },
                                }}
                                barStyle={{
                                    // barWidth: imageList.length == 1 ? 50 : 100,
                                    //    barWidth: this.state.widthOriginal/2,
                                    barWidth: this.state.widthOriginal / 6,
                                }}
                                containerStyle={{
                                    // backgroundColor: TINT_GRAY,
                                    width: Platform.OS !== 'web' ? Dimensions.get('window').width : '100%',
                                    height: Platform.OS !== 'web' ? Dimensions.get('window').height-moderateScale(90) : '100%',

                                    // width: Dimensions.get('window').width,
                                    // height:  Dimensions.get('window').height
                                }}
                                imageList={{
                                    // width:Platform.OS==="web"? Dimensions.get('window').width:typeExport._WIDTH,
                                    // height: Platform.OS==="web"? Dimensions.get('window').height:typeExport._HEIGHT
                                    width: Dimensions.get('window').width,
                                    height: Dimensions.get('window').height,
                                    // width: '100%',
                                    // height: '100%',
                                }}
                                replyView={{
                                    messageList: [1, 2, 3, 4],
                                    isShowReply: true,
                                    onReplyButtonClick: () => {
                                    },
                                    onReplyTextChange: () => {
                                    },
                                }}
                                onChange={position => {
                                    // if (!isUser) {
                                    //     setUserStatusViewed(statusData, position);
                                    // }
                                }}
                            />
*/}

                            <View style={{width: '100%'}}>

                                {
                                    // DataSplashScreenSaina?.info?.weather && <View
                                    //     style={{
                                    //         width: moderateScale(300),
                                    //         height: moderateScale(56),
                                    //         paddingHorizontal: moderateScale(20),
                                    //         //  paddingVertical: moderateScale(8),
                                    //         alignSelf: 'center',
                                    //         flexDirection: "row",
                                    //         borderBottomStartRadius: moderateScale(120),
                                    //         borderBottomEndRadius: moderateScale(120),
                                    //         marginBottom: moderateScale(6),
                                    //         justifyContent: "space-between",
                                    //         // position: "absolute",
                                    //         // bottom: 25,
                                    //         // left: "40%",
                                    //         // borderRadius: 35,
                                    //         // //backgroundColor: "black",
                                    //         // transform: [{ scaleX: 5 }, { scaleY: 1 }],
                                    //         //backgroundColor: "#0087ee"
                                    //         backgroundColor: Colors.colorPrimary
                                    //     }}>
                                    //     <View style={{
                                    //         flex: .33,
                                    //         // flexDirection: "row",
                                    //         alignItems: "center",
                                    //         justifyContent: "center"
                                    //     }}>
                                    //         <HMIcon
                                    //
                                    //
                                    //             //type={"svg"}
                                    //             //uri={DataSplashScreenSaina?.info?.weather?.image_temp}
                                    //             // height={moderateScale(28)}
                                    //             // width={moderateScale(28)}
                                    //
                                    //             type={"image"}
                                    //             source={{uri: DataSplashScreenSaina?.info?.weather?.image_temp}}
                                    //
                                    //
                                    //             style={{
                                    //                 height: moderateScale(32),
                                    //                 width: moderateScale(36),
                                    //                 // fontSize: moderateScale(20),
                                    //                 // color: Colors.blue,
                                    //                 // marginHorizontal: moderateScale(4),
                                    //                 //  marginRight: moderateScale(4),
                                    //                 // marginLeft: moderateScale(4),
                                    //                 //  marginTop: moderateScale(3)
                                    //             }}
                                    //             // styleRoot={{
                                    //             //     width: moderateScale(28),
                                    //             //     height: moderateScale(28),
                                    //             //     borderRadius: moderateScale(12),
                                    //             //     borderWidth: moderateScale(12),
                                    //             //     borderColor: Colors.gray,
                                    //             //     overflow: "hidden",
                                    //             //     marginHorizontal: moderateScale(4)
                                    //             // }}
                                    //         />
                                    //         <HMTextView
                                    //             type={"bold"}
                                    //
                                    //             style={[
                                    //                 {
                                    //                     // position: 'absolute',
                                    //                     //  bottom: 0,
                                    //                     // height: moderateScale(44),
                                    //                     // width: '100%',
                                    //                     textAlign: "center",
                                    //                     color: Colors.white,
                                    //                     fontSize: moderateScale(13),
                                    //                     marginEnd: moderateScale(4),
                                    //                     //  padding: moderateScale(1),
                                    //
                                    //                     // backgroundColor: 'rgba(0,0,0,0.25)',
                                    //                 }]}
                                    //             numberOfLines={2}
                                    //             text={DataSplashScreenSaina?.info?.weather?.temp + "  C°"}
                                    //         />
                                    //
                                    //     </View>
                                    //     <View style={{
                                    //         height: moderateScale(40),
                                    //         width: moderateScale(40),
                                    //         alignSelf: "center",
                                    //         //   flexDirection: "row",
                                    //         alignItems: "center",
                                    //         justifyContent: "center",
                                    //         backgroundColor: Colors.white,
                                    //         borderRadius: moderateScale(20),
                                    //         overflow: "hidden"
                                    //
                                    //     }}>
                                    //
                                    //         <Image
                                    //             resizeMode={"contain"}
                                    //             style={{
                                    //                 height: moderateScale(40),
                                    //                 width: moderateScale(40),
                                    //
                                    //             }}
                                    //             // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                                    //             source={PathFile.image.logo}
                                    //         />
                                    //
                                    //     </View>
                                    //     <View style={{
                                    //         flex: .33,
                                    //         //flexDirection: "row",
                                    //         alignItems: "center",
                                    //         justifyContent: "center"
                                    //     }}>
                                    //
                                    //     {/*    <Image resizeMode={'contain'} source={{
                                    //             uri: 'data:image/png;base64,' + PathFile.base64Image.SelectDate,
                                    //             //   uri:'data:image/png;base64,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',
                                    //             scale: 1
                                    //         }} style={{
                                    //             width: "100%",
                                    //             height: "100%",
                                    //         }}/>*/}
                                    //         <HMIcon
                                    //
                                    //             //source={require('../../../../../assets/img/success.png')}
                                    //             //source={PathFile.image.background}
                                    //             //svg={PathFile.svg.add}
                                    //
                                    //             type={"image"}
                                    //             resizeMode="cover"
                                    //             source={{uri: DataSplashScreenSaina?.info?.image_date}}
                                    //             // source={{
                                    //             //     uri: 'data:image/png;base64,' + PathFile.base64Image.SelectDate,
                                    //             //     scale: 1,
                                    //             // }}
                                    //             style={{
                                    //                 height: moderateScale(28),
                                    //                 width: moderateScale(36),
                                    //             }}
                                    //
                                    //             // type={"svg"}
                                    //             // uri={DataSplashScreenSaina?.info?.image_date}
                                    //             height={moderateScale(28)}
                                    //             width={moderateScale(28)}
                                    //
                                    //
                                    //
                                    //         />
                                    //         <HMTextView
                                    //             type={"bold"}
                                    //
                                    //             style={[
                                    //                 {
                                    //                     // position: 'absolute',
                                    //                     //  bottom: 0,
                                    //                     // height: moderateScale(44),
                                    //                     // width: '100%',
                                    //                     textAlign: "center",
                                    //                     color: Colors.white,
                                    //                     fontSize: moderateScale(14),
                                    //                     marginEnd: moderateScale(4),
                                    //                     //  padding: moderateScale(1),
                                    //
                                    //                     // backgroundColor: 'rgba(0,0,0,0.25)',
                                    //                 }]}
                                    //             numberOfLines={2}
                                    //             text={DataSplashScreenSaina?.info?.currentdate}
                                    //         />
                                    //     </View>
                                    // </View>
                                }


                                {/*                <HMSlider images={typeExport.sliders} autoPlayWithInterval={3000}/>
*/}

                                {/*       <View style={{width: '100%', height:typeExport.WIDTH/1.4}}>
                                    <HMSlider images={results.slider}
                                              autoPlayWithInterval={3000}/>
                                </View>*/}

                                {/*   <Carousel
                                        ref={(c) => { this._carousel = c; }}
                                        data={typeExport.ENTRIES1}
                                        renderItem={this._renderItem}
                                        sliderWidth={typeExport.WIDTH-moderateScale(10)}
                                        itemWidth={moderateScale(100)}
                                        layout={'default'}
                                    />*/}
                                {/*<Carousel
                                        ref={c => this._slider1Ref = c}
                                        data={typeExport.ENTRIES1}
                                        renderItem={this._renderItemWithParallax}
                                        sliderWidth={typeExport.WIDTH}
                                        itemWidth={typeExport.WIDTH - moderateScale(50)}
                                        hasParallaxImages={true}
                                        firstItem={1}
                                        inactiveSlideScale={0.94}
                                        inactiveSlideOpacity={0.7}
                                        // inactiveSlideShift={20}
                                        containerCustomStyle={{
                                            marginTop: 15,
                                            overflow: 'visible' // for custom animations
                                        }}
                                        contentContainerCustomStyle={{paddingVertical: 10}}
                                        loop={true}
                                        loopClonesPerSide={2}
                                        autoplay={true}
                                        autoplayDelay={500}
                                        autoplayInterval={3000}
                                        onSnapToItem={(index) => this.setState({slider1ActiveSlide: index})}
                                    />*/}

                                {
                                    results && results.slider && results.slider.length > 0 ?
                                        <View
                                            style={[{
                                                width: '100%',

                                                height: (this.state.widthOriginal > 600) ? 500 : (Platform.OS === 'web' ? this.state.widthOriginal : typeExport.WIDTH) / 1.6,


                                            }, (this.state.widthOriginal > 1400) && (typeExport._NameApp === 'Cloud' || typeExport._NameApp === 'CloudTest') ? {
                                                flexDirection: 'row',
                                                padding: moderateScale(10),
                                            } : {},

                                            ]}>
                                            {
                                                (checkMenuCloud) &&
                                                <Image source={{uri: 'https://hormozganme.ir/ban2.webp'}}
                                                       style={{
                                                           width: moderateScale(this.state.widthOriginal / 1.6),
                                                           height: ((checkMenuCloud) ? 500 : ((Platform.OS === 'web' ? this.state.widthOriginal : typeExport.WIDTH) / 1.6)) - moderateScale(30),
                                                           // borderRadius: moderateScale(48),
                                                           borderWidth: moderateScale(4),
                                                           borderColor: Colors.colorPrimary,
                                                           marginEnd: moderateScale(8),
                                                           // marginBottom: moderateScale(20)
                                                       }}/>
                                            }
                                            <HMSwiper

                                                list={results.slider}
                                                renderItem={() =>
                                                    results.slider.map((itemSwiper, indexSwiper) => {
                                                        return <DynamicContentSlide
                                                            key={indexSwiper + 'ii'}
                                                            itemSwiper={itemSwiper}
                                                            indexSwiper={indexSwiper}

                                                            DataSplashScreenSaina={DataSplashScreenSaina}
                                                            onPress={() => {

                                                                NavigationService.navigateParams('DetailsScreen', {item: itemSwiper});

                                                            }}
                                                        />;
                                                    })
                                                }
                                            />
                                        </View>
                                        :
                                        null

                                }

                                {/*   {
                                    results && results.slider && results.slider != null && results.slider.length > 0 ?
                                        <View
                                            style={{
                                                backgroundColor: "#43ee37",
                                                width: '100%',
                                                height: (Platform.OS === "web" ? this.state.widthOriginal : typeExport._WIDTH) / (results.slider_height ? results.slider_height : 1.8),
                                            }}>

                                            <Carousel page

                                                      ref={c => this._slider1Ref = c}
                                                // data={ENTRIES1}
                                                      data={results.slider}
                                                //    data={this.state.entries}
                                                      renderItem={this._renderItemWithParallax}
                                                // inactiveSlideScale={.99}
                                                // sliderWidth={sliderWidth}
                                                // itemWidth={itemWidth}

                                                      inactiveSlideScale={1}
                                                      sliderWidth={Platform.OS === "web" ? this.state.sliderWidth : sliderWidth}
                                                //itemWidth={Platform.OS === "web" ? this.state.itemWidth :itemWidth}
                                                // itemWidth={Platform.OS === "web" ? this.state.itemWidth :itemWidth}
                                                      itemWidth={Platform.OS === "web" ? 580 : itemWidth}

                                                      hasParallaxImages={true}
                                                      firstItem={SLIDER_1_FIRST_ITEM}

                                                      inactiveSlideOpacity={0.7}
                                                // inactiveSlideShift={20}
                                                      containerCustomStyle={styles.slider}
                                                      contentContainerCustomStyle={styles.sliderContentContainer}
                                                       // loop={true}
                                                       // loopClonesPerSide={2}
                                                      autoplay={true}
                                                      autoplayDelay={500}
                                                      autoplayInterval={3000}
                                                      onSnapToItem={(index) => this.setState({slider1ActiveSlide: index})}
                                                      removeClippedSubviews={false}
                                            />

                                            <View style={{height: moderateScale(4)}}/>
                                            <Pagination
                                                dotsLength={results.slider.length}
                                                activeDotIndex={slider1ActiveSlide}
                                                containerStyle={styles.paginationContainer}
                                                //  dotColor={'rgba(255, 255, 255, 0.92)'}
                                                dotColor={Colors.colorSecondPrimary}
                                                dotStyle={styles.paginationDot}
                                                inactiveDotColor={Colors.black}
                                                inactiveDotOpacity={0.4}
                                                inactiveDotScale={0.6}
                                                carouselRef={this._slider1Ref}
                                                tappableDots={!!this._slider1Ref}
                                            />
                                        </View>
                                        :
                                        null
                                }
*/}


                            </View>
                            <HMListDiffSize width={this.state.widthOriginal} card={true} title
                                            _backgroundColorLoading={Colors.transparent} _main
                                            data={results ? results.menus : []}/>
                        </View>
                    </ScrollView>
                    {/*   {1 === 1 ?
                                <HMItemAdvertising
                                    item={{id: '1', image: 'https://simple-ad-exchange.com/images/footer.jpg'}}
                                    onPress={() => {
                                        alert("ookk")
                                    }}/>
                                : null}*/}


                    <DialogUpdateAppCustomize/>

                </KeyboardAvoidingView>


                {/*   <Toast ref="toast"/>*/}
            </View>
        );
    }


    _renderItemWithParallax({item, index}, parallaxProps) {
        let {results} = store.getState().reducerSplashGetAllData;

        return (


            <TouchableOpacity
                onPress={() => {
                    // global.typeCategory=item.type;
                    NavigationService.navigateParams('DetailsScreen', {item: item});
                }}
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#fff',
                    //    borderTopRightRadius:moderateScale(8),
                    borderTopEndRadius: moderateScale(12),
                    borderTopStartRadius: moderateScale(8),

                    alignItems: 'center',
                    justifyContent: 'center',
                    // justifyContent:'center',
                    // alignItems:'center'
                }}
            >
                <HMImageView
                    resizeMode={'contain'}
                    uriComplete={item.images.file}
                    _backgroundColorLoading={Colors.black}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: '100%',
                        height: '100%',
                        //   backgroundColor: "#ee7e0c",
                        //  borderTopRightRadius:moderateScale(8),
                        borderTopEndRadius: moderateScale(12),
                        borderTopStartRadius: moderateScale(8),
                    }}
                    //  onLoad={this._onLoad}
                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                />

                {
                    item.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.4)',
                                }]}
                        >
                            <HMTextView
                                type={'bold'}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: 'center',
                                        color: Colors.white,
                                        fontSize: moderateScale(11),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={item.title}
                            />
                        </View>
                        : null
                }
            </TouchableOpacity>

            /*
               {/!* <SliderEntry
                    data={item}
                    even={(index + 1) % 2 === 0}
                    parallax={true}
                    parallaxProps={parallaxProps}
                />*!/}

                */
        );
    }
}

const
    mapStateToProps = state => {
        return {

            token: state.reducerSplashGetAllData.token,
            DataSplashScreen: state.reducerSplashGetAllData,

        };
    };
const
    mapDispatchToProps = dispatch => {
        return {};
    };
export default connect(mapStateToProps, mapDispatchToProps)

(
    MainScreen,
)
;


const delayTime = 300;
let container2 = null;

class DynamicContentSlide extends React.Component {
    constructor(props) {
        super(props);
        container2 = this;
    }

    state = {
        isButtonDisplayed: true,
        firstPress: true,
        lastTime: true,
        backClickCount: 0,


    };

    render() {
        const {itemSwiper, indexSwiper, onPress, onPressLike, DataSplashScreenSaina} = this.props;
        const {isButtonDisplayed, firstPress, lastTime} = this.state;
        let timer = false;
        return (
            <TouchableOpacity
                onPress={onPress}
                style={{
                    flex: 1, alignItems: 'center', justifyContent: 'center',

                    marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#000',
                    //    borderTopRightRadius:moderateScale(8),
                    borderTopEndRadius: moderateScale(12),
                    borderTopStartRadius: moderateScale(8),


                }}
            >
                <HMImageView
                    // resizeMode={(typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") ? 'cover' : "contain"}
                    resizeMode={'cover'}
                    uriComplete={itemSwiper.images.file}
                    _backgroundColorLoading={Colors.white}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: '100%',
                        height: '100%',
                        // backgroundColor: '#000',
                        //  borderTopRightRadius:moderateScale(8),
                        borderTopEndRadius: moderateScale(12),
                        borderTopStartRadius: moderateScale(8),
                    }}
                    //  onLoad={this._onLoad}
                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                />

                {
                    itemSwiper.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }]}
                        >
                            <HMTextView
                                type={'bold'}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: 'center',
                                        color: Colors.white,
                                        fontSize: moderateScale(13),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={itemSwiper.title}
                            />
                        </View>
                        : null
                }


                {DataSplashScreenSaina?.info?.weather && <View style={{
                    width: '100%',
                    height: moderateScale(20),
                    backgroundColor: '#ee2f00',
                    // marginVertical: moderateScale(20),

                    //    borderBottomColor: "#ee2f00",
                    //  borderBottomWidth: moderateScale(6),
                    borderBottomRightRadius: moderateScale(40),
                    borderBottomLeftRadius: moderateScale(40),
                    position: 'absolute',
                    top: 0,
                    overflow: 'hidden',
                }}>
                    <View style={{
                        width: '100%',
                        height: moderateScale(16),
                        backgroundColor: Colors.colorPrimary,
                        // marginVertical: moderateScale(20),

                        //  borderBottomColor: "#ee2f00",
                        // borderBottomWidth: moderateScale(6),
                        borderBottomRightRadius: moderateScale(38),
                        borderBottomLeftRadius: moderateScale(38),
                        position: 'absolute',
                        top: 0,
                        overflow: 'hidden',
                    }}>
                    </View>

                </View>}
            </TouchableOpacity>);
    }


}



